﻿import getResource from '../../core/resources';

const getAccessFieldMetadata = () => {
	return {
		type: 'item',
		itemTypeName: 'Identity',
		label: getResource('toc_editor.access'),
		required: true
	};
};

const getImageFieldMetadata = () => {
	return {
		type: 'image',
		label: getResource('toc_editor.icon')
	};
};

const getLabelFieldMetadata = (state) => {
	const { languages, defaultLanguageCode } = state;
	return {
		defaultLanguageCode,
		label: getResource('toc_editor.label'),
		languages,
		required: true,
		type: 'multiLingual'
	};
};

const getItemTypeFieldMetadata = () => {
	return {
		cssClass: 'aras-form-view__item_distant',
		itemTypeName: 'ItemType',
		label: getResource('toc_editor.itemtype'),
		required: true,
		type: 'item'
	};
};

const propertyMetadataGenerators = {
	access: getAccessFieldMetadata,
	label: getLabelFieldMetadata,
	image: getImageFieldMetadata,
	itemType: getItemTypeFieldMetadata
};

export const getFormMetadata = (stateData, state, order = []) => {
	const { selectedId } = state;
	const relshipItem = stateData.get(selectedId);
	const disabled = relshipItem['@aras.action'] === 'delete';
	return order.reduce((result, property) => {
		const metadata = propertyMetadataGenerators[property](state);
		result[property] = { ...metadata, disabled };
		return result;
	}, {});
};
